import {
  GridColDef,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarFilterButton
} from "@mui/x-data-grid";

import memberList from "./members.json";
import {
  HighRiskLevel,
  LowRiskLevel,
  MediumRiskLevel,
  MemberGrid,
  MemberLink
} from "./VAMemberList.styles";
import moment from "moment";

import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";

const columns: GridColDef[] = [
  {
    field: "name",
    headerName: "Full Name",
    width: 150,
    renderCell: (params) => {
      return <MemberLink href="#">{params?.value}</MemberLink>;
    }
  },
  { field: "dob", headerName: "Date of Birth", width: 130 },
  {
    field: "status",
    headerName: "Status",
    width: 75,
    renderCell: (params) => {
      switch (params?.value) {
        case "Medium":
          return (
            <span>
              <WarningAmberOutlinedIcon>Medium</WarningAmberOutlinedIcon>
            </span>
          );
        case "High":
          return (
            <span>
              <ErrorOutlineRoundedIcon>High</ErrorOutlineRoundedIcon>
            </span>
          );
        default:
          return <span />;
      }
    }
  },
  { field: "protocol", headerName: "Protocol", width: 250 },
  {
    field: "riskLevel",
    headerName: "Risk Level",
    width: 90,
    renderCell: (params) => {
      switch (params?.value) {
        case "Low":
          return <LowRiskLevel />;
        case "Medium":
          return <MediumRiskLevel />;
        case "High":
          return <HighRiskLevel />;
        default:
          return <span />;
      }
    }
  },
  {
    field: "bloodPressure",
    headerName: "Blood Pressure",
    width: 120,
    align: "right",
    renderCell: (params) => {
      const sys = params?.value?.split("/")[0];
      const dia = params?.value?.split("/")[1];
      if (sys > 140 || dia > 90) {
        return (
          <>
            <WarningAmberOutlinedIcon />
            &nbsp;&nbsp;<b>{params?.value}</b>
          </>
        );
      }
      return <span>{params?.value}</span>;
    }
  },
  {
    field: "lastUpdate",
    headerName: "Last Update",
    width: 150,
    valueFormatter: (params) => moment(params?.value).format("MM/DD hh:mmA")
  },
  { field: "careCategory", headerName: "Care Category", width: 270 }
];

const VAMemberList = () => {
  return (
    <div style={{ margin: "20px 0 0 145px", height: 600, width: "87%" }}>
      <MemberGrid
        columns={columns}
        rows={memberList}
        components={{
          Toolbar: () => {
            return (
              <GridToolbarContainer style={{ justifyContent: "flex-end" }}>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
              </GridToolbarContainer>
            );
          }
        }}
      />
    </div>
  );
};

export default VAMemberList;
